// extracted by mini-css-extract-plugin
module.exports = {"cover":"cover-28yTy"};